(() => {
  const planId = item => item.selling_plan_allocation?.selling_plan?.id;
  const matches = (item, variant, plan) => item.variant_id === variant && planId(item) === plan && item.quantity > 0;
  const managedItems = cart => cart.items.filter(item => item.product_id === 16580881842444 && (
    item.properties?._anom_funnel_key === 'quotidien-main' ||
    (Object.keys(item.properties || {}).length === 4 && item.properties['Café'] === 'Blend Signature ANOM' && item.properties.Offre === 'Quotidien' && item.properties.Rythme === 'Mensuel' && typeof item.properties['Livraison récurrente'] === 'string')
  ));
  const identity = item => JSON.stringify([
    item.variant_id, planId(item) || null,
    Object.entries(item.properties || {}).sort(([a], [b]) => a.localeCompare(b))
  ]);
  const sameLine = (a, b) => identity(a) === identity(b);
  function verifyAdded(before, after, variant, plan, price, quantity = 1) {
    if (!Array.isArray(before.items) || !Array.isArray(after.items)) return false;
    const added = after.items.filter(item => matches(item, variant, plan) && item.properties?._anom_funnel_key === 'quotidien-main');
    if (added.length !== 1 || added[0].quantity !== quantity || added[0].original_price !== price) return false;
    // Adding an offer must preserve every existing cart line, including its properties.
    return before.items.every(old => after.items.some(item => identity(item) === identity(old) && item.quantity === old.quantity));
  }
  window.AnomQuotidienCart = Object.freeze({ matches, managedItems, sameLine, verifyAdded });
})();
